import React from 'react'

const ForwardIcon = ({
  width = 24,
  height = 24,
  color = '#CCCCCC',
  className = '',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M9 16V11.5H7.5V10H10.5V16H9ZM12.5 16C12.2167 16 11.9792 15.9042 11.7875 15.7125C11.5958 15.5208 11.5 15.2833 11.5 15V11C11.5 10.7167 11.5958 10.4792 11.7875 10.2875C11.9792 10.0958 12.2167 10 12.5 10H14.5C14.7833 10 15.0208 10.0958 15.2125 10.2875C15.4042 10.4792 15.5 10.7167 15.5 11V15C15.5 15.2833 15.4042 15.5208 15.2125 15.7125C15.0208 15.9042 14.7833 16 14.5 16H12.5ZM13 14.5H14V11.5H13V14.5ZM12 22C10.75 22 9.57917 21.7625 8.4875 21.2875C7.39583 20.8125 6.44583 20.1708 5.6375 19.3625C4.82917 18.5542 4.1875 17.6042 3.7125 16.5125C3.2375 15.4208 3 14.25 3 13C3 11.75 3.2375 10.5792 3.7125 9.4875C4.1875 8.39583 4.82917 7.44583 5.6375 6.6375C6.44583 5.82917 7.39583 5.1875 8.4875 4.7125C9.57917 4.2375 10.75 4 12 4H12.15L10.6 2.45L12 1L16 5L12 9L10.6 7.55L12.15 6H12C10.05 6 8.39583 6.67917 7.0375 8.0375C5.67917 9.39583 5 11.05 5 13C5 14.95 5.67917 16.6042 7.0375 17.9625C8.39583 19.3208 10.05 20 12 20C13.95 20 15.6042 19.3208 16.9625 17.9625C18.3208 16.6042 19 14.95 19 13H21C21 14.25 20.7625 15.4208 20.2875 16.5125C19.8125 17.6042 19.1708 18.5542 18.3625 19.3625C17.5542 20.1708 16.6042 20.8125 15.5125 21.2875C14.4208 21.7625 13.25 22 12 22Z"
      fill={color}
    />
  </svg>
)

export default ForwardIcon
